export const STAGE = process.env.NEXT_PUBLIC_ENV || 'local';

export const DD_SERVICE_NAME = 'online-booking-frontend';
export const DD_APP_ID = '84796279-6b58-470f-a873-71d8da3bec8e';
export const DD_TOKEN = 'pub96f524bd704a015d5f607ff08b916041';
export const POSTHOG_PUBLIC_KEY = 'phc_M0evhRSqD5Lyev0Al9zbWCsfJFU77KpTSPsDFbMD9gW';

const ENVIROMENTS = {
  local: {
    BASE_URL: 'http://dev.localhost:5000',
    APPS_SERVER: 'http://dev.localhost:5000/graphql',
    PII_SERVER: 'http://pii.dev.localhost:3200/graphql',
    PII_PUBLIC_SERVER: 'http://pii.dev.localhost:3200/graphql/public',
  },
  dev: {
    // BASE_URL: 'https://dev.prenuvo.com',
    // APPS_SERVER: 'https://dev.prenuvo.com/graphql',
    // PII_SERVER: 'https://pii.dev.prenuvo.com/graphql',
    // PII_PUBLIC_SERVER: 'https://pii.dev.prenuvo.com/graphql/public',
    BASE_URL: 'https://staging.prenuvo.com',
    APPS_SERVER: 'https://staging.prenuvo.com/graphql',
    PII_SERVER: 'https://pii.staging.prenuvo.com/graphql',
    PII_PUBLIC_SERVER: 'https://pii.staging.prenuvo.com/graphql/public',
  },
  stg: {
    BASE_URL: 'https://staging.prenuvo.com',
    APPS_SERVER: 'https://staging.prenuvo.com/graphql',
    PII_SERVER: 'https://pii.staging.prenuvo.com/graphql',
    PII_PUBLIC_SERVER: 'https://pii.staging.prenuvo.com/graphql/public',
  },
  prd: {
    BASE_URL: 'https://www.prenuvo.com',
    APPS_SERVER: 'https://www.prenuvo.com/graphql',
    PII_SERVER: 'https://pii.prenuvo.com/graphql',
    PII_PUBLIC_SERVER: 'https://pii.prenuvo.com/graphql/public',
  },
};

export const CONFIG = {
  ...ENVIROMENTS[STAGE as keyof typeof ENVIROMENTS],
};

export default CONFIG;
